import { configurationSettings } from '../../../../configuration';
import { addMonetaryValues } from '../../../../utils/monetary-value-utils';
import { getItemById } from '../../../sales-data/selectors/items/get-item-by-id';
import { getOrderItems } from './get-order-items';
export const getOrderTippableItemsTotalPrice = () => {
    const { includeSundryItems } = configurationSettings.data.order.tip;
    let items = [...getOrderItems()];
    if (!includeSundryItems) {
        // TODO: revert to getOrderRelatedItemById #318239
        items = items.filter(item => { var _a; return !((_a = getItemById(item.itemId)) === null || _a === void 0 ? void 0 : _a.isSundry); });
    }
    return addMonetaryValues(...items.map(item => item.price));
};
//# sourceMappingURL=get-order-tippable-items-total-price.js.map